import { Input } from "reactstrap";
import { OrderData } from "../../../../../Data/General/Dashboard/Default";
import { Btn, H6, Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { Link } from "react-router-dom";

const OrderBody = () => {
  return (
    <tbody>
      {OrderData.map((item, index) => (
        <tr key={index}>
          <td>
            <div className="form-check">
              <Input type="checkbox" />
            </div>
          </td>
          <td>
            <div className="d-flex">
              <div className="flex-shrink-0">
                <Image src={dynamicImage(item.image)} alt="" />
              </div>
              <div className="flex-grow-1">
                <Link to={`${process.env.PUBLIC_URL}/applications/users/user-profile`}>
                  <H6>{item.name}</H6>
                  <span>{item.code}</span>
                </Link>
              </div>
            </div>
          </td>
          <td>
            <H6>{item.day}</H6>
            <span>{item.time}</span>
          </td>
          <td>{item.product}</td>
          <td>{item.amount}</td>
          <td>
            <Btn color="transparent" className={item.status_class}>{item.status}</Btn>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default OrderBody;
